import { useState, useEffect, useContext,useRef } from "react";
import { DataContext } from "../../../context/DataContext";
import { toast } from "sonner";
import { NavLink, useNavigate } from "react-router-dom";
import { petitions } from "../../../api/calls";
import TableLoad from "../../componentsTools/TableLoad";
import Table from "../../componentsTable/Table";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";
import { useForm } from "react-hook-form";

export default function VerES() {
  const { session, idEmpresa } = useContext(DataContext);
  const [fechas, setFechas] = useState({ fInicio: "", fFin: "" });
  const [filtering, setFiltering] = useState("");
  const [loadI, setLoadI] = useState(true);
  const [loadG, setLoadG] = useState(true);
  const [estado, setEstado] = useState(true);

  const [inventario, setInventario] = useState([]);
  const [guiasRemision, setGuiasRemision] = useState([]);

  const modalEmail = useRef(null);
  const modalWsp = useRef(null);

  const form1 = useForm({
    defaultValues: {
      "tipo": "",
      id: "",
      email: "",
    },
  });  

  const form2 = useForm({
    defaultValues: {
      "tipo": "",
      id: "",
      numero: "",
      indice: "51",
    },
  });

  const columnsInventario = [
    {
      header: "Comprobante",
      accessorFn: (row) =>
        `${row.tipComprobante}-${row.serComprobante}-${row.nroComprobante}`,
      cell: ({ row }) => (
        <td className="product align-middle ps-2 text-start">
          <span className="badge text-bg-primary fs-9 rounded-4">
            <span className="badge-label">
              {" "}
              {row.original.tipComprobante}-{row.original.serComprobante}-{" "}
              {row.original.nroComprobante}
            </span>
          </span>
        </td>
      ),
    },
    {
      header: "Tipo",
      accessorKey: "tipo",
      cell: ({ row }) => (
        <td className="product align-middle fw-bold">
          {row.original.tipo === "C" ? "Entrada" : "Salida"}
        </td>
      ),
    },
    {
      header: "Fecha",
      accessorKey: "fecha",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary">
          {row.original.fecha}
        </td>
      ),
    },
    {
      header: "Usuario",
      accessorKey: "usuario",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary fw-bold">
          {row.original.usuario}
        </td>
      ),
    },
    {
      header: "Origen",
      accessorKey: "origen",
      cell: ({ row }) => (
        <td className="product align-middle ps-2">{row.original.origen}</td>
      ),
    },
    {
      header: "Moneda",
      accessorKey: "moneda",
      cell: ({ row }) => (
        <td className="product align-middle ps-4 fw-bold">
          {row.original.moneda}
        </td>
      ),
    },
    {
      header: "Importe total",
      accessorKey: "impTotal",
      cell: ({ row }) => (
        <td className="price align-middle white-space-nowrap text-start fw-bold text-body-tertiary ps-4">
          {row.original.impTotal.toFixed(2)}
        </td>
      ),
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <td className="product align-middle ps-4">
          <div className="btn-reveal-trigger position-static">
            <button
              className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
              type="button"
              data-bs-toggle="dropdown"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              disabled={row.original.anulado === "S"}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="fas fa-ellipsis-h fs-10"></span>
            </button>
            <div className="dropdown-menu dropdown-menu-end py-2" onClick={(e) => e.stopPropagation()}>
              <button className="dropdown-item" onClick={() => printInventario(row.original)}>
                <span className="fa-solid fas fa-print text-body-secondary me-2"></span>
                <span className="text-body-secondary">Imprimir</span>
              </button>
              <button className="dropdown-item" onClick={() => abrirModalEmailInventario(row.original)}>
                <span className="fa-solid fas fa-envelope text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por email</span>
              </button>
              <button
                className="dropdown-item"
                onClick={() => abrirModalWspInventario(row.original)}
              >
                <span className="fa-solid fab fa-whatsapp text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por WhatsApp</span>
              </button>
              <button className="dropdown-item" onClick={() => getReportInventario(row.original)}>
                <span className="fa-solid fas fa-file-pdf text-body-secondary me-2"></span>
                <span className="text-body-secondary">Descargar PDF</span>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item text-info" onClick={() => handleRowClickInventario(row.original)}>
                <span>Editar</span>
              </button>
              {["09", "31", "GE"].includes(row.original.tipComprobante) && (
                <button
                  className="dropdown-item text-danger"
                  onClick={() => canceledInventario(row.original)}
                >
                  <span>Anular</span>
                </button>
              )}
            </div>
          </div>
        </td>
      ),
    },
  ];

  const columnsGuiaRemision = [
    {
      header: "Guía",
      accessorFn: (row) =>
        `${row.tipComprobante}-${row.serComprobante}-${row.nroComprobante}`,
      cell: ({ row }) => (
        <td className="product align-middle ps-2 text-start">
          <span className="badge text-bg-primary fs-9 rounded-4">
            <span className="badge-label">
              {" "}
              {row.original.tipComprobante}-{row.original.serComprobante}-{" "}
              {row.original.nroComprobante}
            </span>
          </span>
        </td>
      ),
    },
    {
      header: "Destinatario",
      accessorKey: "razon",
      cell: ({ row }) => (
        <td className="product align-middle ps-2">{row.original.razon}</td>
      ),
    },
    {
      header: "Fecha",
      accessorKey: "fecha",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary">
          {row.original.fecha}
        </td>
      ),
    },
    {
      header: "Origen",
      accessorKey: "puntPartida",
      cell: ({ row }) => (
        <td className="product align-middle ps-2">
          {row.original.puntPartida}
        </td>
      ),
    },
    {
      header: "Destino",
      accessorKey: "puntLlegada",
      cell: ({ row }) => (
        <td className="product align-middle ps-2">
          {row.original.puntLlegada}
        </td>
      ),
    },
    {
      header: "Moneda",
      accessorKey: "moneda",
      cell: ({ row }) => (
        <td className="product align-middle ps-4 fw-bold">
          {row.original.moneda}
        </td>
      ),
    },
    {
      header: "Importe total",
      accessorKey: "impTotal",
      cell: ({ row }) => (
        <td className="price align-middle white-space-nowrap text-start fw-bold text-body-tertiary ps-4">
          {row.original.impTotal.toFixed(2)}
        </td>
      ),
    },
    {
      header: "Estado",
      accessorKey: "informado",
      cell: ({ row }) => (
        <td className="product align-middle">
          {" "}
          {row.original.informado === "-" ? (
            <span className="badge badge-phoenix fs-10 badge-phoenix-secondary rounded-4 border-0">
              <span className="badge-label">Pendiente</span>
            </span>
          ) : (
            <span className="badge badge-phoenix fs-10 badge-phoenix-primary rounded-4 border-0">
              <span className="badge-label">Informado</span>
            </span>
          )}{" "}
        </td>
      ),
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <td className="product align-middle ps-4">
          <div className="btn-reveal-trigger position-static">
            <button
              className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
              type="button"
              data-bs-toggle="dropdown"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              disabled={row.original.anulado === "S"}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="fas fa-ellipsis-h fs-10"></span>
            </button>
            <div className="dropdown-menu dropdown-menu-end py-2" onClick={(e) => e.stopPropagation()}>
              <button className="dropdown-item" onClick={() => printSalida(row.original)}>
                <span className="fa-solid fas fa-print text-body-secondary me-2"></span>
                <span className="text-body-secondary">Imprimir</span>
              </button>
              <button className="dropdown-item" onClick={() => abrirModalEmailGuiaRemision(row.original)}>
                <span className="fa-solid fas fa-envelope text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por email</span>
              </button>
              <button
                className="dropdown-item"
                onClick={() => abrirModalWspGuiaRemision(row.original)}
              >
                <span className="fa-solid fab fa-whatsapp text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por WhatsApp</span>
              </button>
              <button className="dropdown-item" onClick={() => getReportSalida(row.original)}>
                <span className="fa-solid fas fa-file-pdf text-body-secondary me-2"></span>
                <span className="text-body-secondary">Descargar PDF</span>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={() => toast.info("Funcionalidad disponible pronto")}>
                <span className="fa-solid far fas fa-lightbulb text-body-info me-2"></span>
                <span className="text-info">Verificar estado en SUNAT</span>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item text-info" onClick={() => handleRowClickGuiaRemision(row.original)}>
                <span>Editar</span>
              </button>
              {["09", "31", "GE"].includes(row.original.tipComprobante) && (
                <button
                  className="dropdown-item text-danger"
                  onClick={() => canceledInventario(row.original)}
                >
                  <span>Anular</span>
                </button>
              )}
            </div>
          </div>
        </td>
      ),
    },
  ];

  const abrirModalWspInventario = async (row) => {
    form2.reset();
    form2.setValue("id", row.id);
    form2.setValue("tipo", row.tipo);
    const modal = new window.bootstrap.Modal(modalWsp.current); 
    modal.show();
  }

  const abrirModalWspGuiaRemision = async (row) => {
    form2.reset();
    form2.setValue("id", row.idVentas);
    form2.setValue("tipo", "V");
    const modal = new window.bootstrap.Modal(modalWsp.current); 
    modal.show();
  }

  const abrirModalEmailInventario = (row) => {
    form1.reset();
    form1.setValue("id", row.id);
    form1.setValue("tipo", row.tipo);
    const modal = new window.bootstrap.Modal(modalEmail.current); 
    modal.show();
  };

  const abrirModalEmailGuiaRemision = (row) => {
    form1.reset();
    form1.setValue("id", row.idVentas);
    form1.setValue("tipo", "V");
    const modal = new window.bootstrap.Modal(modalEmail.current); 
    modal.show();
  }

  const getReportSalida = async (row) => {
    const response = await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      row?.idVentas
    );

    if (response.isError) {
      toast.error(response.data || "No se pudo obtener el reporte");
      return;
    }

    const blob = new Blob([response.blob], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${row.tipComprobante + "-" + row.serComprobante + "-" + row.nroComprobante}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  }

  const printSalida = async (row) => {
    const response = await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      row?.idVentas
    );
    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = fileURL;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  }

  const getReportInventario = async (row) => {
    const response = row.tipo === "C" ? await petitions.getReportEntrada(
      idEmpresa(),
      session().token,
      row?.id
    ) : await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      row?.id || row?.idVentas,
    )

    if (response.isError) {
      toast.error(response.data || "No se pudo obtener el reporte");
      return;
    }

    const blob = new Blob([response.blob], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${row.tipComprobante + "-" + row.serComprobante + "-" + row.nroComprobante}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  }

  const printInventario = async (row) => {
    const response = row.tipo === "C" ? await petitions.getReportEntrada(
      idEmpresa(),
      session().token,
      row?.id
    ) : await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      row?.id || row?.idVentas,
    )

    if (response.isError) {
      toast.error(response.data || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = fileURL;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  }  

  const canceledInventario = (row) => {    
    const status = row.tipo === "C";

    toast(
      "¿Estas seguro/a de anular esta " +
        (status ? "Entrada" : "Salida") +
        " " +
        row?.tipComprobante +
        "-" +
        row?.serComprobante +
        "-" +
        row?.nroComprobante +
        "?",
      {
        action: {
          label: "Si, anular",
          onClick: async () => {
            const response = status
              ? await petitions.anularCompra(idEmpresa(), session().token, {
                  idCompras: row?.id,
                })
              : await petitions.anularVenta(idEmpresa(), session().token, {
                  idVenta: row?.id || row?.idVentas,
                });

            if (response.status === "success") {
              toast.success(
                (status ? "Entrada" : "Salida") +
                  " " +
                  row?.tipComprobante +
                  "-" +
                  row?.serComprobante +
                  "-" +
                  row?.nroComprobante +
                  " anulada correctamente"
              );
              if (estado) {
                LoadInventario(fechas);
              } else {
                LoadGuiaRemision(fechas);
              }
            } else {
              const msg =
                typeof response.code === "string"
                  ? response.message
                  : response.data;
              toast.error(msg);
            }
          },
        },
      }
    );
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFechas((prevFechas) => ({
      ...prevFechas,
      [name]: value,
    }));
  };

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formatDate = (date) => date.toISOString().split("T")[0];

    const fechasIniciales = {
      fInicio: formatDate(firstDay),
      fFin: formatDate(lastDay),
    };

    setFechas(fechasIniciales);
    LoadInventario(fechasIniciales);
  }, []);

  const LoadInventario = async ({ fInicio, fFin }) => {
    if (!fInicio || !fFin) return;
    setLoadI(true);
    const response = await petitions.getInventario(
      idEmpresa(),
      session().token,
      fInicio,
      fFin
    );

    if (response.status === "success") {
      setInventario(response.data);
      setLoadI(false);
    } else {
      const msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  const LoadGuiaRemision = async ({ fInicio, fFin }) => {
    if (!fInicio || !fFin) return;
    setLoadG(true);
    const response = await petitions.getGuiasRemision(
      idEmpresa(),
      session().token,
      fInicio,
      fFin
    );

    if (response.status === "success") {
      setGuiasRemision(response.data);
      setLoadG(false);
    } else {
      const msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  const navigate = useNavigate();

  const handleRowClickInventario = (row) => {
    const isInventario = ["GE", "09", "31"].includes(row.tipComprobante);
    if (isInventario) {
      navigate("/main/editinventory", {
        replace: true,
        state: { id: row.id, tipo: row.tipo === "C" ? "E" : "S", main:"/main/VerES" },
      });
      return;
    }

    const path = row.tipo === "C" ? "/main/editbuy" : "/main/viewsale";
    const state = row.tipo === "C" ? { idCompra: row.id, main:"/main/VerES" } : { idVenta: row.id, main:"/main/VerES" };

    navigate(path, { replace: true, state });
  };

  const handleRowClickGuiaRemision = (row) => {
    navigate("/main/editinventory", {
      replace: true,
      state: { id: row.idVentas, tipo: "S", main:"/main/VerES" },
    });
  };

  const sendEmail = form1.handleSubmit(async (data) => {
    const promise =  (data.tipo === "C") ? petitions.sendEmailCompra(
      idEmpresa(),
      session().token,
      data.id,
      data.email
    ): petitions.sendEmailVenta(
        idEmpresa(),
        session().token,
        data.id,
        data.email
      );

    toast.promise(promise, {
      loading: 'Enviando email...',
      success: (response) => {
        if (response.status === "success") {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEmail.current);
          modalInstance.hide();
          return "Email enviado correctamente";
        } else {
          throw new Error(response.message || response.data || "Error desconocido");
        }
      },
      error: (err) => {
        if (err?.status === "error") {
          return err.message || err.data || "Error al enviar el email";
        }
        return "Error... :( Intenta de nuevo!";
      }
    });
  });

  const sendWsp = form2.handleSubmit(async (data) => {
    const response = data.tipo === "C" ? await petitions.getReportEntrada(
      idEmpresa(),
      session().token,
      data?.id
    ) : await petitions.getReportSalida(
      idEmpresa(),
      session().token,
      data?.id
    )

    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    var url = `https://wa.me/${data.indice}${data.numero}?text=${"Buenas tardes, adjunto el comprobante electronico: " + fileURL}`;
    window.open(url, '_blank'); 

    const modalInstance = window.bootstrap.Modal.getInstance(modalWsp.current);
    modalInstance.hide();
    toast.success("Mensaje enviado por WhatsApp");
  })

  return (
    <>
      <div className="mb-9">
        <div className="row g-3 mb-1">
          <div className="col-auto">
            <h2 className="mb-0">Inventario</h2>
          </div>
        </div>
        <ul className="nav nav-links mb-3 mb-lg-2 mx-n3">
          {estado ? (
            <>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-secondary">Todos </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({inventario.length})
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-primary">Entradas </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({inventario?.filter((v) => v.tipo === "C").length})
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-primary">Salidas </span>
                  <span className="text-body-tertiary fw-semibold">
                    <span className="text-body-tertiary fw-semibold">
                      ({inventario?.filter((v) => v.tipo === "V").length})
                    </span>
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-warning">Ajustes </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({inventario?.filter((v) => v.origen === "Ajuste").length})
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-danger">Anulados </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({inventario?.filter((v) => v.anulado !== "S").length})
                  </span>
                </div>
              </li>
            </>
          ) : (
            <>
            <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-secondary">Todos </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({guiasRemision.length})
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-info">Informados </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({guiasRemision?.filter((v) => v.informado !== "-").length})
                  </span>
                </div>
              </li>
               <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-success">Activos </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({guiasRemision?.filter((v) => v.anulado === "N").length})
                  </span>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link disabled" aria-current="page">
                  <span className="text-danger">Anulados </span>
                  <span className="text-body-tertiary fw-semibold">
                    ({guiasRemision?.filter((v) => v.anulado === "S").length})
                  </span>
                </div>
              </li>
            </>
          )}
        </ul>
        <div className="mb-3">
          <div className="row g-1">
            <div className="col-auto">
              <div className="search-box">
                <form className="position-relative">
                  <input
                    className="form-control search-input search rounded-4 border-0 shadow-sm"
                    type="search"
                    placeholder={
                      "Buscar " + (estado ? "inventario" : "guías de remisión")
                    }
                    aria-label="Search"
                    value={filtering}
                    onChange={(e) => setFiltering(e.target.value)}
                  />
                  <span className="fas fa-search search-box-icon"></span>
                </form>
              </div>
            </div>
            <div className="col-auto scrollbar overflow-hidden-y flex-grow-3 mb-2">
              <div className="btn-group position-static" role="group">
                <div className="d-flex align-items-center gap-3">
                  <label className="form-label" htmlFor="datepickerDesde">
                    Desde
                  </label>
                  <input
                    className="form-control rounded-4 border-0 shadow-sm"
                    id="datepickerDesde"
                    type="date"
                    name="fInicio"
                    value={fechas.fInicio}
                    onChange={handleDateChange}
                  />

                  <label className="form-label" htmlFor="datepickerHasta">
                    Hasta
                  </label>
                  <input
                    className="form-control rounded-4 border-0 shadow-sm"
                    id="datepickerHasta"
                    type="date"
                    name="fFin"
                    value={fechas.fFin}
                    onChange={handleDateChange}
                  />

                  <button
                    className="btn px-3 btn-phoenix-secondary rounded-4"
                    type="button"
                    onClick={() => {
                      estado
                        ? LoadInventario(fechas)
                        : LoadGuiaRemision(fechas);
                      setFiltering("");
                    }}
                  >
                    <span
                      className="fa-solid fa-filter text-primary"
                      data-fa-transform="down-3"
                    ></span>
                  </button>

                  <div className="me-2">
                    <button
                      className="btn px-3 btn-phoenix-secondary rounded-4"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-boundary="window"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-bs-reference="parent"
                      disabled={true}
                    >
                      <span className="fa-solid fa-ellipsis"></span>
                    </button>
                    <ul
                      className="dropdown-menu dropdown-menu-end p-0"
                      style={{ zIndex: 9999 }}
                    >
                      <li>
                        <a className="dropdown-item" href="#!">
                          View profile
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#!">
                          Report
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#!">
                          Manage notifications
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item text-danger" href="#!">
                          Delete Lead
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-link text-body me-4 px-0"
                onClick={() => {
                  estado
                    ? exportToExcel_v1(
                        inventario,
                        columnsInventario,
                        "Inventario"
                      )
                    : exportToExcel_v1(
                        guiasRemision,
                        columnsGuiaRemision,
                        "GuiasDeRemisión"
                      );
                }}
              >
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <NavLink className="btn btn-primary rounded-4" to={"/main/NuevaES"}>
                <span className="fas fa-plus me-2"></span>Agregar
              </NavLink>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-table-responsive scrollbar mx-n1 px-1">
            <ul
              className="nav nav-underline w-100 d-flex"
              id="myTab"
              role="tablist"
            >
              <li
                className="nav-item flex-fill text-center"
                role="presentation"
              >
                <a
                  className="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  href="#tab-home"
                  role="tab"
                  aria-controls="tab-home"
                  aria-selected="true"
                  onClick={() => {
                    setEstado(true);
                    LoadInventario(fechas);
                    setFiltering("");
                  }}
                >
                  Inventario
                </a>
              </li>
              <li
                className="nav-item flex-fill text-center"
                role="presentation"
              >
                <a
                  className="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  href="#tab-profile"
                  role="tab"
                  aria-controls="tab-profile"
                  aria-selected="false"
                  onClick={() => {
                    setEstado(false);
                    LoadGuiaRemision(fechas);
                    setFiltering("");
                  }}
                >
                  Guías de remisión
                </a>
              </li>
            </ul>
            <div className="tab-content mt-3" id="myTabContent">
              <div
                className="tab-pane fade active show"
                id="tab-home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                {loadI ? (
                  <TableLoad />
                ) : (
                  <Table
                    data={inventario}
                    columns={columnsInventario}
                    filtering={filtering}
                    setFiltering={setFiltering}
                    handleRowClick={handleRowClickInventario}
                    classNameTable={"table fs-9 mb-0 table-hover"}
                  />
                )}
              </div>
              <div
                className="tab-pane fade"
                id="tab-profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                {loadG ? (
                  <TableLoad />
                ) : (
                  <Table
                    data={guiasRemision}
                    columns={columnsGuiaRemision}
                    filtering={filtering}
                    setFiltering={setFiltering}
                    handleRowClick={handleRowClickGuiaRemision}
                    classNameTable={"table fs-9 mb-0 table-hover"}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalEmail}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendEmail}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por correo electronico
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        @
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form1.register("email", {
                          required: "El email es requerido",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email no válido",
                          },
                        })}
                      />
                    </div>
                    {form1.formState.errors.email && (
                      <span className="text-danger">
                        {form1.formState.errors.email.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4" 
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalWsp}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendWsp}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por WhatsApp
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        +
                      </span>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="51"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("indice", {
                          required: "El número es requerido",
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.indice && (
                      <span className="text-danger">
                        {form2.formState.errors.indice.message}
                      </span>
                    )}
                  </div>
                  <div className="col-lg-8">
                    <div className="input-group mb-1">
                      <input
                        className="form-control"
                        type="number"
                        placeholder="999 999 999"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("numero", {
                          required: "El número es requerido",
                          pattern: {
                            value: /^\+?[1-9]\d{1,14}$/,
                            message: "Número no válido",
                          },
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.numero && (
                      <span className="text-danger">
                        {form2.formState.errors.numero.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
